import { Box } from "@mui/material";
import DefaultText from "../../../../../../../components/typography/default-text";
import styles from "./styles.module.css";
import {
  premiosPorAno,
  getAnosPorColuna,
} from "./premiosPorAno";
import {
  sxAnoHeader,
  sxCertificationItem,
  sxItalicText,
  sxPremioIcon,
  sxPremioIconPlaceholder,
} from "./sxProps";

const CertificationsDesktop: React.FC = () => {
  const colunas = getAnosPorColuna();

  return (
    <div className={styles["certifications-content"]}>
      {colunas.map((anos, colIndex) => (
        <div key={colIndex} className={styles["certifications-column"]}>
          {anos.map((ano) => (
            <div key={ano} className={styles["ano-block"]}>
              <span className={styles["ano"]}>
                <DefaultText sx={sxAnoHeader} component="span">{ano}</DefaultText>
              </span>
              {premiosPorAno[ano].map((premio, idx) => (
                <Box key={idx} sx={sxCertificationItem}>
                  {premio.icone ? (
                    <Box component="img" src={premio.icone} alt="" sx={sxPremioIcon} />
                  ) : (
                    <Box sx={sxPremioIconPlaceholder} aria-hidden />
                  )}
                  <DefaultText sx={sxItalicText}>{premio.nome}</DefaultText>
                </Box>
              ))}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default CertificationsDesktop;
